












import { Component, Vue } from 'vue-property-decorator';
import { General } from '@/services/General';
import axios from 'axios';
import { saveAs } from 'file-saver';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

@Component({
    components: {
        VuePdfEmbed
    } 
})
export default class EmergencyPolicyPage extends Vue {
    contactCulture: any = null;
    loading: boolean = false;
    fileLoaded: boolean = false;
    pdfSource: string = null;

    async mounted() {
        this.loading = true;

        await this.GetEmergencyContactCulture();
        await this.ConfirmContactPolicyOpened();

        this.pdfSource = await this.downloadPrivacyNoticeBase64();
        this.loading = false;
        this.fileLoaded = true;
    }

    async GetEmergencyContactCulture(){        
        try {
            let id = this.$route.params.id;
            let response: any = await axios({
                method: 'get',
                url: General.GetApiUrl(`/api/EmergencyContact/GetEmergencyContactCulture/${id}`),
                withCredentials: true,
                responseType: 'json'
            });

            this.contactCulture = response.data;
        } catch (error) {
            General.HandleError(error, this);
        }
    }

    async ConfirmContactPolicyOpened() {
        try {
            let id = this.$route.params.id;
            await axios({
                method: 'get',
                url: General.GetApiUrl(`/api/EmergencyContact/SetContactPolicyAsOpened/${id}`),
                withCredentials: true,
                responseType: 'json'
            });

        } catch (error) {
            General.HandleError(error, this);
        }
    }

    async downloadPrivacyNotice(): Promise<Array<any>> {
        try {
            
            this.loading = true;
            let response = await axios.get<any>(
                General.GetApiUrl('/api/EmergencyContact/DownloadPrivacyNotice?idCulture=' + this.contactCulture.idCulture), 
                {
                    responseType: 'blob',
                }
            );
            let fileName = General.getFileNameFromHeader(response.headers);
            saveAs(new Blob([response.data]), fileName);
            return response.data;
        } catch (ex) {
            General.HandleError(ex, this);
            return null;
        } finally {
            this.loading = false;
        }
    }

    async downloadPrivacyNoticeBase64(): Promise<string> {
        try {
            
            this.loading = true;
            let response = await axios.get<any>(
                General.GetApiUrl('/api/EmergencyContact/DownloadPrivacyNoticeBase64?idCulture=' + this.contactCulture.idCulture)
            );

            return `data:application/pdf;base64,${response.data}`;
        } catch (ex) {
            General.HandleError(ex, this);
            return null;
        } finally {
            this.loading = false;
        }
    }
}

